<div class="maintenance-mode-wrapper">
  <div class="maintenance-mode-info">
    <fto-logo class="maintenance-mode-logo"></fto-logo>

    <p>
      PowerReady is undergoing scheduled maintenance. The site will be down until approximately {{ retryAfter }} while
      we update our system. Your Site Administrator has been sent more information about what is included in this
      maintenance.
    </p>
    <p>
      Thanks you for your patience and please contact us at
      <a href="mailto:support@powerdms.com">support&#64;powerdms.com</a> if you have any questions.
    </p>
  </div>
</div>
